// Obtener oferta
const oferta = require(`./${_BBVA_CAMP}.js`).default;

export default oferta;
